import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

import { components } from 'components/ui/select';
import type { MenuProps } from 'react-select';
import type { QuickbooksEntity } from '../types';

interface CustomSelectProps {
  isCreating?: boolean;
  onCreateClick?: () => void;
  type: string;
}

interface Props extends MenuProps<QuickbooksEntity> {
  selectProps: MenuProps<QuickbooksEntity>['selectProps'] & CustomSelectProps;
}

export default function QuickbooksSelectMenu(props: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const menuProps = props as any;

  if (props.selectProps.isCreating) {
    return (
      <components.Menu {...menuProps}>
        <div className="d-flex justify-content-center px-4 py-5">
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      </components.Menu>
    );
  }

  if (props.selectProps.inputValue && props.options.length) {
    return (
      <components.Menu {...menuProps}>
        {props.children}
        {props.selectProps.onCreateClick && (
          <div className="p-2 border-top">
            <a aria-label="new" className="clickable" onClick={props.selectProps.onCreateClick}>
              + Create QuickBooks {props.selectProps.type}
            </a>
          </div>
        )}
      </components.Menu>
    );
  }

  let content: React.ReactNode;
  if (props.isLoading) {
    content = 'Searching...';
  } else if (props.selectProps.inputValue) {
    content = (
      <>
        <div>No QuickBooks {props.selectProps.type}s found</div>
        {props.selectProps.onCreateClick && (
          <a aria-label="new" className="clickable mt-2" onClick={props.selectProps.onCreateClick}>
            + Create QuickBooks {props.selectProps.type}
          </a>
        )}
      </>
    );
  } else {
    content = `Enter QuickBooks ${props.selectProps.type} name`;
  }

  return (
    <components.Menu {...menuProps}>
      <div className="d-flex flex-column align-items-center text-center px-4 py-5">
        {content}
      </div>
    </components.Menu>
  );
}
